import type { TourConfig } from './types';

export const clientsTour: TourConfig = {
  id: 'clients-page',
  name: 'Clients Tour',
  description: 'Learn how to manage your clients',
  requiredPath: '/dashboard/clients',
  steps: [
    {
      element: '[data-tour="clients-header"]',
      popover: {
        title: 'Client Management',
        description:
          'Manage all your active clients here. Track their health profiles, diet plans, and progress.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="clients-add-button"]',
      popover: {
        title: 'Add New Client',
        description:
          'Create a new client directly, or convert a qualified lead to a client.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="clients-search"]',
      popover: {
        title: 'Search Clients',
        description:
          'Find clients quickly by their code, name, or phone number.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="clients-status-filter"]',
      popover: {
        title: 'Filter by Status',
        description:
          'Filter clients by subscription status: Active, Expired, Overdue, No Plan, etc.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="clients-table"]',
      popover: {
        title: 'Client List',
        description:
          'View all your clients. Click on a client name to see their full profile with diet plans, vitals, and more.',
        side: 'top',
        align: 'center',
      },
    },
  ],
};
